"use client"

import { createContext } from "react"

export const HandoffContext = createContext<{
  enabled: boolean | undefined
  handoff: unknown
}>({
  enabled: undefined,
  handoff: undefined,
})

export function HandoffProvider<T>({
  children,
  enabled = true,
  handoff,
}: {
  children: React.ReactNode
  enabled?: boolean
  handoff: T
}) {
  const value = { enabled, handoff }

  return (
    <HandoffContext.Provider value={value}>{children}</HandoffContext.Provider>
  )
}
